<script setup lang="ts">
import { NuxtLink } from '#components'
import type { PropType } from 'vue'
import HomeFloatingBoxCollection from '~/layers/homepage/components/box/HomeFloatingBoxCollection.vue'
import UVideo from '~/layers/ui/components/UVideo.vue'
import type { THomeSectionCollection } from '~/layers/homepage/data/types'

defineProps({
  section: {
    type: Object as PropType<THomeSectionCollection>,
    required: true,
  },
})
</script>

<template>
  <component
    :is="section.link ? NuxtLink : 'div'"
    class="main__picture main__picture--home-section-collection"
    :class="{ main__picture_square: section.pictureSquare }"
    :to="section.link ? section.link : null"
  >
    <UVideo
      v-if="section.video"
      class="home-section-collection-video"
      autoplay
      muted
      playsinline
      :poster="section.poster"
    >
      <source
        media="(min-width:1024px)"
        :src="section.video!.desktop"
        type="video/mp4"
      />
      <source
        media="(max-width:1023px)"
        :src="section.video!.mobile"
        type="video/mp4"
      />
    </UVideo>
    <URemotePicture v-else :picture="section.picture" :isLazy="false" />
  </component>
  <HomeFloatingBoxCollection :section />
</template>

<style lang="scss">
  a.main__picture {
    &--home-section-collection {
      display: block;
    }
  }

  .video-container.home-section-collection-video {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
</style>
